import styled from 'styled-components';
import { colors, spacing } from '@ardoq/design-tokens';
import { BUTTON_SELECTOR } from '@ardoq/button';
import { header5 } from '@ardoq/typography';

export const ViewOptionsRow = styled.div`
  display: flex;
  padding: ${spacing.s16};
  align-items: center;
  gap: ${spacing.s8};
  align-self: stretch;
`;

export const ViewOptionsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding-top: ${spacing.s8};
`;

export const ViewOptionsSectionHeader = styled.div`
  display: flex;
  padding: ${spacing.s8} ${spacing.s16};
  align-items: center;
  gap: ${spacing.s8};
  align-self: stretch;
`;

export const ViewOptionsSectionTitleContainer = styled.div`
  display: flex;
  padding: 0;
  align-items: center;
  gap: ${spacing.s8};
  flex: 1 0 0;
`;

export const ViewOptionsSectionTitle = styled.h3`
  ${header5};
  color: ${colors.textSubtle};
  margin: 0;
`;

export const ViewOptionsSectionBody = styled.div.attrs({ role: 'listbox' })`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const ViewOptionsSectionRowContainer = styled.div`
  display: flex;
  padding: ${spacing.s8} ${spacing.s16};
  align-items: center;
  gap: ${spacing.s8};
  align-self: stretch;
  cursor: pointer;
  &:hover {
    background-color: ${colors.surfaceHover};
  }
`;

export const ViewOptionsSectionRowContent = styled.div`
  display: flex;
  padding: 0;
  align-items: center;
  gap: ${spacing.s8};
  flex: 1 1 100%;
  overflow: hidden;
  white-space: nowrap;
  overflow-wrap: anywhere;
`;

export const ViewOptionsSectionRowLabel = styled.label`
  margin: 0;
  color: ${colors.textDefault};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: inherit;
  flex: 1 1 0;
  min-width: 0;
  white-space: normal;
`;

export const ViewOptionsSectionRightControls = styled.div`
  display: flex;
  justify-content: end;
  margin-left: auto;
  align-items: center;
  gap: ${spacing.s4};
  flex: 0 1 auto;
  min-width: 0;
  > ${BUTTON_SELECTOR} {
    min-height: 24px;
  }
`;
